import { computed, ref } from 'vue'

// New key: every browser starts once on the new default; a later click is remembered as before.
const STORAGE_KEY = 'oc.projectionModelBackend.v25-ocdev2-default'
const DEFAULT_BACKEND = 'ocdev2'

// 'local' = this VM's old Python worker, 'oct' = oct's gateway,
// 'ocdev2' = oct's V25 release served locally by the isolated v25-ocdev2 project.
// Since 2026-10-28 only ocdev2 is offered; a stored 'local'/'oct' falls back to it.
const BACKENDS = ['ocdev2']
const LABELS = { local: 'Local Python', oct: 'OCT remote', ocdev2: 'V25 · ocdev2' }

const backend = ref(readStoredBackend())

function readStoredBackend() {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return BACKENDS.includes(stored) ? stored : DEFAULT_BACKEND
  } catch {
    return DEFAULT_BACKEND
  }
}

export function backendLabel(value) {
  return LABELS[value] || LABELS.local
}

export function useProjectionModelBackend() {
  const isOct = computed(() => backend.value === 'oct')
  const isOcdev2 = computed(() => backend.value === 'ocdev2')
  const label = computed(() => backendLabel(backend.value))

  const setBackend = (value) => {
    backend.value = BACKENDS.includes(value) ? value : DEFAULT_BACKEND
    try {
      localStorage.setItem(STORAGE_KEY, backend.value)
    } catch {
      // ignore quota / private-mode failures
    }
  }

  return { backend, isOct, isOcdev2, label, setBackend }
}
